import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios
import { GuiasService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import QRCode from 'react-qr-code';
import GuiasList from './GuiasList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';
import qr_code from '../../assets/imgs/qr-code.png';

function GuiasListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const FormMethods = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);
    const [QRModalContent, setQRModalContent] = useState();
    const [tableData, setTableData] = useState(buildTableData());
    const [GuiasListData, setGuiasListData] = useState([]);

    const EnableBtn = parseInt(FormMethods.watch('myViniedo'));

    useEffect(() => {
        const getMyGuias = async () => {
            try {
                setLoader(true);
                const MyGuias = await GuiasService.all({
                    token,
                    usuarioId: user.id,
                    // serie: parseInt(dayjs(new Date()).format('YYYY')),
                });
                if (MyGuias) {
                    setGuiasListData(MyGuias.data);
                    setTableData(buildTableData(MyGuias.data));
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };
        if (user.tipo !== 3) getMyGuias();
    }, []);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJCPs*/
    function buildTableData(data = []) {
        return {
            title: 'Guías',
            headers: [
                'Guia',
                'Viñedo',
                'Fecha',
                'Matrícula Vehículo',
                'Estado',
                'Kilos Totales',
                ' ',
            ],
            pagination: 10,
            data: data
                ? data?.map((g) => {
                      return {
                          guia: 
                            g.guia_Papel ? (
                                `${g.serie}-G-${g.numero} / ${g.guia_Papel}` ) : `${g.serie}-G-${g.numero}`
                            ,
                          //`${g.serie}-G-${g.numero} / ${g.guia_Papel}`                          ,
                          viniedo: g.viniedo,
                          fecha: dayjs(g.fecha_Envio).format('DD-MM-YYYY'),
                          matricula: g.matricula_Vehiculo,
                          estado: masters?.GuiaStateTypes?.find(
                              (ht) => ht.id === g.estado
                          )?.nombre.replace('_', ' '),
                          kilosTotales: g.total_Kilos,
                          icons: (
                              <div>
                                  <Link
                                      to={RoutesApp.Guias.single + g.id}
                                      className="table-icon_container"
                                  >
                                      <img
                                          className="table-icon"
                                          src={right_arrow}
                                          title="Visualizar"
                                          alt="Visualizar"
                                      />
                                  </Link>
                                  {g.estado !== 2 && (
                                      <Link
                                          to={RoutesApp.Guias.new + g.id}
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={pencil}
                                              title="Editar"
                                              alt="Editar"
                                          />
                                      </Link>
                                  )}
                                  {g.estado === 1 && (
                                      <div
                                          className="table-icon_container"
                                          onClick={() => {
                                              setQRModalContent(
                                                  <section>
                                                      <QRCode
                                                          value={
                                                              process.env
                                                                  .REACT_APP_URL +
                                                              RoutesApp.Guias
                                                                  .qr +
                                                              g.token_QR
                                                          }
                                                          size={150}
                                                          level="M"
                                                      />
                                                  </section>
                                              );
                                              setOpenModal(true);
                                          }}
                                      >
                                          <img
                                              className="table-icon"
                                              src={qr_code}
                                              title="QR"
                                              alt="QR"
                                          />
                                      </div>
                                  )}
                              </div>
                          ),
                      };
                  })
                : [],
        };
    }

    async function newGuia(data) {
        try {
            setLoader(true);
            const NewGuia = await GuiasService.create({
                token,
                viniedoId: parseInt(data.myViniedo),
            });
            if (NewGuia) {
                Navigate(RoutesApp.Guias.new + NewGuia.data.cabecera.id);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    }

    return loader ? (
        <Spinner />
    ) : (
        <>
            <GuiasList
                functions={{
                    ...FormMethods,
                    newGuia,
                }}
                states={{
                    GuiasListData,
                    tableData,
                    viniedos,
                    settings,
                    EnableBtn,
                }}
            />
            <Modal
                title={'Guía'}
                isOpen={OpenModal}
                onClose={() => setOpenModal(!OpenModal)}
            >
                {QRModalContent}
            </Modal>
        </>
    );
}

export default GuiasListContainer;
